<template>
  <div class="search_tips_expanded box-shadow box-shadow-wide">
    <button class="btn btn-sm btn-outline-primary mr-2 t-600 py-0"
      type="button"
      @click="insertAroundPosition('quotes')"
    >" "</button>
    <button class="btn btn-sm btn-outline-primary mr-2 t-600 py-0"
      type="button"
      @click="insertAroundPosition('quotesTilde')"
    >" "~</button>
    <button class="btn btn-sm btn-outline-primary mr-2 t-600 py-0"
      type="button"
      @click="insertAtPosition(' AND ')"
    >AND</button>
    <button class="btn btn-sm btn-outline-primary mr-2 t-600 py-0"
      type="button"
      @click="insertAtPosition(' OR ')"
    >OR</button>
    <button class="btn btn-sm btn-outline-primary mr-2 t-600 py-0"
      type="button"
      @click="insertAroundPosition('brackets')"
    >( )</button>
    <button class="btn btn-sm btn-outline-primary mr-2 t-600 py-0"
      type="button"
      @click="insertAtPosition('~')"
    >~</button>

    <a href="#" @click.prevent="$emit('hide')" class="t-secondary pull-right fa fa-close t-lr" />

    <h2 class="mt-3 t-grey">Example searches</h2>
    <table>
      <tr>
        <td class="text-nowrap align-text-top pr-4"><mark>"</mark>neurodegenerative diseases<mark>"</mark></td>
        <td class="pb-2">Finds results that contain <strong>both the words</strong> neurodegenerative and diseases, in the <strong>same order</strong> with <strong>nothing</strong> in between.</td>
      </tr>
      <tr>
        <td class="text-nowrap align-text-top pr-4"><mark>"</mark>neurodegenerative diseases<mark>"~5</mark></td>
        <td class="pb-2">Finds results that contain <strong>both the words</strong> neurodegenerative and diseases, in <strong>whatever order</strong>, with <strong>max. 5 other terms</strong> in between.</td>
      </tr>
      <tr>
        <td class="text-nowrap align-text-top pr-4">neurodegenerative <mark>AND</mark> diseases</td>
        <td class="pb-2">Finds results that must contain <strong>both the words</strong> neurodegenerative and diseases, in <strong>whatever order</strong>, with <strong>any number of words</strong> in between.</td>
      </tr>
      <tr>
        <td class="text-nowrap align-text-top pr-4">neurodegenerative <mark>OR</mark> diseases</td>
        <td class="pb-2">Finds results that must contain <strong>either of the words</strong> neurodegenerative and diseases.</td>
      </tr>
      <tr>
        <td class="text-nowrap align-text-top pr-4"><mark>"</mark>gene therapy<mark>" AND (</mark>AAV <mark>OR</mark> Cd4<mark>)</mark></td>
        <td class="pb-2">Finds results that must contain <strong>both the words</strong> gene and therapy in the <strong>same order</strong> with <strong>nothing</strong> in between, <strong>and either of the words</strong> AAV and Cd4.</td>
      </tr>
      <tr>
        <td class="text-nowrap align-text-top pr-4">Stephen<mark>~2</mark></td>
        <td>Finds results that contain Stephen, Steven, Stephan, … or any other term with <strong>max. 2 character changes</strong>. Use this when you are not sure about spelling.</td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  name: 'searchTips',
  props: {
    synonyms: {
      type: Object,
      required: false
    },
    searchInput: {
      required: true
    },
    currentKeyword: {
      required: false,
      default: '',
      type: String
    }
  },
  methods: {
    insertAroundPosition (type) {
      let symbols = [] // Array of 2 symbols, "start" and "end" of the operator we want to insert
      switch (type) {
        case 'quotes':
          symbols.push('"', '"')
          break
        case 'brackets':
          symbols.push('(', ')')
          break
        case 'quotesTilde':
          symbols.push('"', '"~5')
          break
      }

      let keyword = this.currentKeyword
      let cursorPosition = this.searchInput.selectionStart
      let endCursorPosition = this.searchInput.selectionEnd
      let endPosition, firstHalf, lastHalf, middle

      if (cursorPosition === endCursorPosition) {
        firstHalf = keyword.substring(0, cursorPosition)
        lastHalf = keyword.substring(cursorPosition)

        keyword = `${firstHalf}${symbols.join('')}${lastHalf}`
        // Just insert the characters, put cursor in between
        endPosition = cursorPosition + symbols[0].length
      } else {
        // insert operator symbols around
        firstHalf = keyword.substring(0, cursorPosition)
        middle = keyword.substring(cursorPosition, endCursorPosition)
        lastHalf = keyword.substring(endCursorPosition)
        keyword = `${firstHalf}${symbols[0]}${middle}${symbols[1]}${lastHalf}`
        endPosition = endCursorPosition + symbols[0].length + symbols[1].length
      }

      this.$emit('updateKeyword', keyword)
      this.searchInput.focus()
      this.$nextTick(() => {
        this.searchInput.setSelectionRange(endPosition, endPosition)
      })
    },
    insertAtPosition (character) {
      let keyword = this.currentKeyword

      let cursorPosition = this.searchInput.selectionStart

      // They had us at the first half, this order of operations is importante
      let firstHalf = keyword.substring(0, cursorPosition)
      let lastHalf = keyword.substring(cursorPosition)
      if (firstHalf && firstHalf.endsWith(' ')) {
        firstHalf = firstHalf.substring(0, firstHalf.length - 1)
        cursorPosition -= 1
      }
      if (lastHalf && lastHalf.startsWith(' ')) lastHalf = lastHalf.substring(1)

      const endPosition = cursorPosition + character.length

      keyword = `${firstHalf}${character}${lastHalf}`

      // this.handleKeyDown(keyword)
      this.$emit('updateKeyword', keyword)

      this.searchInput.focus()
      this.$nextTick(() => {
        this.searchInput.setSelectionRange(endPosition, endPosition)
      })
    }
  }
}
</script>
